import { closeChecklistURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { getName } from 'utils/users/config';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import { TaskDeletedNotification } from 'types/inbox-notifications/close/ChecklistNotifications';

export function DeletedNotificationItem({
  item,
}: {
  item: TaskDeletedNotification;
}) {
  const { usersMap } = useUsersData();
  const actorName = getName(item.actor_id, usersMap);
  if (!item.task) {
    return <div>Notification task not found</div>;
  }

  return (
    <GenericNotificationItem
      item={item}
      url={closeChecklistURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`${actorName} deleted a task.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}
